import React, {useEffect, useState} from 'react'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useContentAsset} from '../../hooks/use-content-asset'
import RichTextBox from '../../page-designer/assets/rich-textbox'

const CategoryContentAsset = (props) => {
    const params = props
    const contentAsset = useContentAsset(params)
    const body = contentAsset?.[params?.id]?.body
    const contentAssetBody = body ? body : null

    const [isContentLoaded, setContentLoaded] = useState(false)
    useEffect(() => {
        setContentLoaded(true)
    }, [])

    return (
        contentAssetBody &&
        contentAssetBody.trim() && (
            <Box
                className="center-read-more-button"
                sx={{
                    '& button': {
                        display: 'flex',
                        justifyContent: 'center',
                        margin: '1rem auto 0 auto'
                    }
                }}
            >
                {isContentLoaded && (
                    <RichTextBox
                        richText={{value: contentAssetBody}}
                        readMore={true}
                        readMoreText="Show More"
                        readLessText="Show Less"
                        contentPosition="left"
                        textSizeDefault={14}
                        textSizeTablet={16}
                        textSizeDesktop={18}
                        supres
                    />
                )}
            </Box>
        )
    )
}

export default CategoryContentAsset
